import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, NgZone } from '@angular/core';
import { IgxSnackbarComponent } from 'igniteui-angular';
import { timeInterval } from 'rxjs/operators';
import { SnackbarStates } from 'src/app/enums/snack-bar/snack-bar';


@Component({
  selector: 'app-admin-snackbar',
  templateUrl: './admin-snackbar.component.html',
  styleUrls: ['./admin-snackbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminSnackbarComponent implements OnInit, AfterViewInit {

  public timeout = 5000;
  state: SnackbarStates = SnackbarStates.NOTIFICATION;
  SnackStates = SnackbarStates;
 

  @ViewChild("snackbarNotification", { static: true, read: IgxSnackbarComponent })
  public snackbarNotification: IgxSnackbarComponent;

  @ViewChild("snackbarMain", { static: true, read: IgxSnackbarComponent })
  public snackbarMain: IgxSnackbarComponent;

  @ViewChild("loadingContent", { static: true, read: ElementRef })
  public loadingContentDIV: ElementRef;

  @ViewChild("notificationContent", { static: true, read: ElementRef })
  public notificationContentDIV: ElementRef;

  raiseLoader = false;
  raiseNotification = false;

  lastTimeoutNotification: NodeJS.Timeout; 
  LastInterval1: any;
  LastInterval2: any;
  LastInterval3: any;

  constructor(private zone: NgZone) { }
  
  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    
  }
  
  hide(event, element){
    const hostClasses = (event.path[0] as HTMLElement).classList;
    if(hostClasses.contains('igx-snackbar__button')) element.hide();
  }

  public showLoader(msg){
    this.state = SnackbarStates.LOADING;
    this.raiseLoader = true;
    this.snackbarMain.autoHide = false;
    (this.loadingContentDIV.nativeElement as HTMLElement).innerHTML = msg;
    this.snackbarMain.show();
  }

  Message : string;

  ShowPopUp(){
    const parentThis = this;
    this.raiseNotification = true;
    this.raiseLoader = false;
    (this.notificationContentDIV.nativeElement as HTMLElement).innerHTML = this.Message;
    this.snackbarNotification.show();

    //this.lastTimeoutNotification =  
    window.setTimeout( parentThis.HidePopUp.bind(parentThis), 4000); 
  }

  HidePopUp()
  {
    this.snackbarNotification.hide();
 
    this.state = SnackbarStates.NONE;
    this.raiseNotification = false;
   
  }
 
 
   showNotification(msg, state = undefined){
    this.zone.run(() => { 
        clearTimeout(this.lastTimeoutNotification);
        this.snackbarMain.hide();
        this.snackbarNotification.hide();
        this.state = state === undefined ? SnackbarStates.NOTIFICATION : state;
 
          // this.sncak 
          setTimeout(() => {
            this.raiseNotification = true;
            this.raiseLoader = false;
              (this.notificationContentDIV.nativeElement as HTMLElement).innerHTML = msg;
              this.snackbarNotification.show();
              
              this.lastTimeoutNotification =  setTimeout(() => {
                this.snackbarNotification.hide();
              
                setTimeout(() => {
                  this.state = SnackbarStates.NONE;
                  this.raiseNotification = false;
                }, 100);

      
              }, 4000); 

          }, 400);

      });

   } 
  
}
